module.exports = __webpack_public_path__ + "static/omakuva-7b9879ccb4c750273ab3407cc6b6611e.jpg";